var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCaret(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "7px",
    viewBox: "0 0 12 7",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Caret Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.6812998,6.87057435 L0.132166849,1.48059271 C-0.0440556163,1.30802518 -0.0440556163,1.02897981 0.132166849,0.856412274 L0.874550851,0.129425649 C1.05077332,-0.043141883 1.33572879,-0.043141883 1.51195126,0.129425649 L6,4.48033045 L10.4880487,0.129425649 C10.6642712,-0.043141883 10.9492267,-0.043141883 11.1254491,0.129425649 L11.8678332,0.856412274 C12.0440556,1.02897981 12.0440556,1.30802518 11.8678332,1.48059271 L6.3187002,6.87057435 C6.14247774,7.04314188 5.85752226,7.04314188 5.6812998,6.87057435 Z",
    fill: "#146A5D"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCaret);
export default __webpack_public_path__ + "static/media/Icon_Caret.efb04e5e.svg";
export { ForwardRef as ReactComponent };